import React from 'react'
import {Route, useParams} from 'react-router-dom'
import DefaultPageLayout from '../../layout/DefaultPageLayout'

const DefaultPageRoute = ({path, exact, component: Component, render, ...rest}: {
	path: string,
	exact?: boolean,
	component?: any,
	render?: any,
	rest?: any
}) =>
{
	const params = useParams()
	const matchProps = {match: {params}}
	return (
		<DefaultPageLayout>
			<Component {...matchProps} />
		</DefaultPageLayout>
	)
}

export default DefaultPageRoute
